import { HOST_TOOL_NAMES } from "../../turns/turn-constants";
import { labelOnly } from "../label-only";
import type { ToolActivity } from "../tool-activity";
import type { ToolActivityState } from "../tool-activity-state";

export const model3dToolActivityDescribers: readonly [
  string,
  (record: Record<string, unknown>, state: ToolActivityState) => ToolActivity,
][] = [
  [HOST_TOOL_NAMES.MODEL3D_LIST, () => labelOnly("Listed the 3D models")],
  [HOST_TOOL_NAMES.MODEL3D_CREATE, () => labelOnly("Created a 3D model")],
  [HOST_TOOL_NAMES.MODEL3D_READ, () => labelOnly("Read the 3D model")],
  [
    HOST_TOOL_NAMES.MODEL3D_SOURCE_RESTORE,
    () => labelOnly("Restored the Blender source"),
  ],
  [
    HOST_TOOL_NAMES.MODEL3D_PUBLISH,
    () => labelOnly("Published a 3D model version"),
  ],
];
